import { useMemo } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router";
import Home from "./pages/guest_pages/Home";
import CategoryProductsPage from "./pages/guest_pages/CategoryProductsPage";
import CategoryDetailPage from "./pages/guest_pages/CategoryDetailPage";
import ArticleDetailPage from "./pages/guest_pages/ArticleDetailPage";
import PartnersPage from "./pages/guest_pages/PartnersPage";
import PartnerOnboardPage from "./pages/guest_pages/PartnerOnboardPage";
import AboutPage from "./pages/guest_pages/AboutPage";
import FAQsPage from "./pages/guest_pages/FAQsPage";
import ContactPage from "./pages/guest_pages/ContactPage";
import PrivacyPolicyPage from "./pages/guest_pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/guest_pages/TermsAndConditionsPage";
import CookiePolicyPage from "./pages/guest_pages/CookiePolicyPage";
import Error404 from "./pages/Error404";
import GuestRoutes from "./routes/guestRoutes";
import ProfilePage from "./pages/consumer_pages/ProfilePage";
import ProtectedRoute from "./utils/ProtectedRoute";
import { Navbar } from "./components/navigation";
import ScrollToTop from "./components/navigation/ScrollToTop";
import ScrollToTopButton from "./components/navigation/ScrollToTopButton";
import { useCategories } from "./contexts/CategoriesContext";

function App() {
  const location = useLocation();
  const { industries } = useCategories();
  const hideNavbarOnPaths = [
    "/signin",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/verify-account",
  ];
  const shouldShowNavbar = !hideNavbarOnPaths.includes(location.pathname);

  const categoryPaths = useMemo(
    () =>
      industries.length
        ? industries
            .map((industry) => String(industry?.path || "").replace(/^\//, ""))
            .filter(Boolean)
        : ["legal", "real-estate", "nutrition", "health", "careers", "betting-gaming"],
    [industries],
  );

  return (
    <div className="min-h-screen bg-[#f7f4ec]">
      <ScrollToTop />
      {shouldShowNavbar ? <Navbar /> : null}
      <ScrollToTopButton />
      <Routes>
        <Route path="/" element={<Home />} />

        {categoryPaths.map((categoryPath) => (
          <Route key={categoryPath} path={`/${categoryPath}`} element={<CategoryProductsPage />} />
        ))}
        {categoryPaths.map((categoryPath) => (
          <Route
            key={`${categoryPath}-article`}
            path={`/${categoryPath}/:slug/:articleSlug`}
            element={<ArticleDetailPage />}
          />
        ))}
        {categoryPaths.map((categoryPath) => (
          <Route
            key={`${categoryPath}-detail`}
            path={`/${categoryPath}/:slug`}
            element={<CategoryDetailPage />}
          />
        ))}

        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/partners/onboard" element={<PartnerOnboardPage />} />
        <Route path="/partners/:draftCode/onboard" element={<PartnerOnboardPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />

        <Route path="/dashboard" element={<Navigate to="/profile" replace />} />
        <Route path="/dashboard/*" element={<Navigate to="/profile" replace />} />

        <Route path="/*" element={<GuestRoutes />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </div>
  );
}

export default App;
